import type { ErrorTestFunction } from "../interface";

export const coupled: ErrorTestFunction = (field, { value }, compare) =>
    value !== compare?.value && `${compare?.name} e ${field} devem ser iguais`;
